import React from 'react';
import { useUnifiedDashboardQuery } from '@/hooks/useUnifiedDashboardQuery';
import { DashboardDataAdapter } from '@/services/dashboard/DashboardDataAdapter';
import { useCacheWarming } from '@/hooks/useCacheWarming';


export const useOptimizedDashboardData = () => {
  // Initialize cache warming
  useCacheWarming();
  
  // Use unified dashboard query for batch optimization
  const {
    recentRuns,
    recentFitness,
    bodyComposition,
    progressPhotos,
    personalRecords,
    stravaConnection,
    isLoading,
    errors
  } = useUnifiedDashboardQuery();

  // Enhanced data processing with intelligent suggestions (centralized)
  const runningCoachData = React.useMemo(
    () => DashboardDataAdapter.buildRunningCoachData(recentRuns),
    [recentRuns]
  );

  const fitnessCoachData = React.useMemo(
    () => DashboardDataAdapter.buildFitnessCoachData(recentFitness),
    [recentFitness]
  );

  return {
    // General dashboard data (unified & cached)
    recentBodyComp: bodyComposition,
    recentRun: recentRuns?.[0],
    photoCount: progressPhotos?.length || 0,

    // Coach-specific data (optimized)
    runningCoachData,
    runningCoachLoading: isLoading,
    fitnessCoachData,
    fitnessCoachLoading: isLoading,

    // Enhanced data
    personalRecords,
    stravaConnection,
    progressPhotos,

    // Convenience flags
    isLoading,
    hasData: !!(recentRuns?.length || recentFitness?.length || runningCoachData || fitnessCoachData),
    dashboardLoading: isLoading,
    errors,
  };
};